/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-08-15 14:46:56
 * @LastEditors: K
 * @LastEditTime: 2022-09-13 18:12:19
 */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { api, sendAsync } from '../.././app/applicationSlice'
import { RootState, RootThunk, RootThunkApi } from '../../app/store'
import * as S from '../../services/advertising'

// 广告列表
export const advertisingListAsync = createAsyncThunk<
  void,
  S.advertisingListParams,
  RootThunkApi<void>
>('diagnosis/getTreatments', async (params, api) => {
  return sendAsync(S.advertisingList(params), api)
})

// 保存广告页
export const advertisingAsync = createAsyncThunk<
  void,
  S.AdvertisingParams,
  RootThunkApi<void>
>('diagnosis/advertisingAsync', async (params, api) => {
  return sendAsync(S.advertising(params), api)
})
export const advertisingAsync2 = createAsyncThunk<
  void,
  S.AdvertisingParams,
  RootThunkApi<void>
>('diagnosis/advertisingAsync2', async (params, api) => {
  return sendAsync(S.advertising2(params), api)
})
// 列表-删除
export const deleteList = createAsyncThunk<
  void,
  S.deleteListFnParams,
  RootThunkApi<void>
>('diagnosis/deleteList', async (params, api) => {
  return sendAsync(S.deleteListFn(params), api)
})
// 列表-编辑
export const updateList = createAsyncThunk<
  void,
  S.AdvertisingParams,
  RootThunkApi<void>
>('diagnosis/updateList', async (params, api) => {
  return sendAsync(S.updateListFn(params), api)
})
export const updateList2 = createAsyncThunk<
  void,
  S.AdvertisingParams,
  RootThunkApi<void>
>('diagnosis/updateList2', async (params, api) => {
  return sendAsync(S.updateListFn2(params), api)
})